import React, {useEffect} from 'react';
import {getTestTake} from "features/model/service/test/test-student/test-take/getTestTake";
import {useAppDispatch, useAppSelector} from "common/hook";
import {Preloader} from "components/layout/preloader/Preloader";
import {Group} from "features/model/types/groups/groupsSchema";
import {NothingYetMessage} from "components/pages/personal-cabinet/nothing-yet-message/NothingYetMessage";
import {StudentTestItems} from "components/pages/test/students-test/student-test-item/StudentTestItem";
import {CustomPagination} from "components/pagination/CustomPagination";
import {TestTakeItem} from "features/model/types/test/test-student/test-take/testTakeShema";

export const StudentsTest = () => {
    const dispatch = useAppDispatch()
    const TestTakeData = useAppSelector(state => state.testsTake)

    const {tests, isLoading, pagination} = TestTakeData

    const {page, pageSize, pageCount} = pagination


    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(getTestTake({page: value - 1}));
    };

    useEffect(() => {
        dispatch(getTestTake({}))
    }, []);


    return (
        <div className="data-tbl tests-tbl">
            <div className="row thead">
                <div className="col test-col auto-width">Тест</div>
                <div className="col group-col">Занятие</div>
                <div className="col status-col">Статус</div>
            </div>

            {isLoading ? (
                <Preloader />
            ) : (
                tests && tests.length > 0 ? (
                    tests.map((test: TestTakeItem) => (
                        <StudentTestItems test={test} key={test.id} />
                    ))
                ) : (
                    <NothingYetMessage />
                )
            )}

            {pageCount > 1 && (
                <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle} />
            )}

        </div>
    );
};

